import { PUT_INFO_TALENT_START } from '../../types';

export const put_info_talent = (payload) => ({
  type: PUT_INFO_TALENT_START,
  payload,
});
